export default __webpack_public_path__ + "static/media/mobilemintpop.5dc9bcb1.png";